import { AutogenLayoutTariffRegionList } from "./autogen/AutogenLayoutTariffRegionList";

export class TariffRegionList extends AutogenLayoutTariffRegionList {

    onLoad() {
        this.mainDataSource.search();
    }
}
